// src/reducers/hotels_reducer.js
import {
  HOTELS_REQUEST,
  HOTELS_SUCCESS,
  HOTELS_FAILURE,
  HOTELS_SET_SELECTION,
  HOTELS_SET_VIEW_MODE,        // <-- NEW
} from "../actions/hotel_actions";

const initialState = {
  items: [],
  loading: false,
  error: null,
  selection: { continent: null, country: null, city: null },
  viewMode: "grid", // "grid" | "list" (default)
};

export default function hotelsReducer(state = initialState, action) {
  switch (action.type) {
    case HOTELS_REQUEST:
      return { ...state, loading: true, error: null };
    case HOTELS_SUCCESS:
      return { ...state, loading: false, items: action.payload || [], error: null };
    case HOTELS_FAILURE:
      return { ...state, loading: false, error: action.error || "Failed to load hotels" };

    case HOTELS_SET_SELECTION:
      return {
        ...state,
        selection: { ...state.selection, ...action.payload },
      };

    case HOTELS_SET_VIEW_MODE: // <-- NEW
      return { ...state, viewMode: action.payload || "grid" };

    default:
      return state;
  }
}
